var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block"},[_c('div',{staticClass:"\n    handle cursor-move\n    w-4 pl-1 h-full\n    flex items-center\n    hover:opacity-50\n  "},[_c('IconDrag')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }